/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserLvl
 */
export interface UserLvl {
    /**
     * 
     * @type {string}
     * @memberof UserLvl
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof UserLvl
     */
    level: number;
    /**
     * 
     * @type {string}
     * @memberof UserLvl
     */
    email: string;
    /**
     * 
     * @type {number}
     * @memberof UserLvl
     */
    id?: number;
}

/**
 * Check if a given object implements the UserLvl interface.
 */
export function instanceOfUserLvl(value: object): value is UserLvl {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('level' in value) || value['level'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function UserLvlFromJSON(json: any): UserLvl {
    return UserLvlFromJSONTyped(json, false);
}

export function UserLvlFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserLvl {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'level': json['level'],
        'email': json['email'],
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function UserLvlToJSON(json: any): UserLvl {
    return UserLvlToJSONTyped(json, false);
}

export function UserLvlToJSONTyped(value?: UserLvl | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'level': value['level'],
        'email': value['email'],
        'id': value['id'],
    };
}

